import { render, staticRenderFns } from "./SimpleAiStarIcon.vue?vue&type=template&id=0132e7fc&scoped=true&"
import script from "./SimpleAiStarIcon.vue?vue&type=script&setup=true&lang=ts&"
export * from "./SimpleAiStarIcon.vue?vue&type=script&setup=true&lang=ts&"


/* normalize component */
import normalizer from "!../../../../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "0132e7fc",
  null
  
)

export default component.exports